import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { EnumDevice, EnumBrowser } from '@libs/constants';
import { DeviceDetectionService, BrowserDetectionService, ScaleLayoutService } from '@libs/libraries/frontend';

import { AppearancePreferenceService } from '../../../../services/shared/layout-preferences/appearance-preference.service';
import { APPEARANCE_PREFERENCE_VISIBILITY_ANIMATION } from '../../../../services/shared/layout-preferences/appearance-preference.animation';


@Component({
    selector: 'app-scale-layout',
    templateUrl: './scale-layout.component.html',
    styleUrls: ['./scale-layout.component.scss'],
	standalone: false,
	animations: [APPEARANCE_PREFERENCE_VISIBILITY_ANIMATION]
})
export class ScaleLayoutComponent implements OnInit {

	@ViewChild('zoomLayoutDropdown') zoomLayoutDropdown: NgbDropdown;

	//** Configurations */
	readonly SCALING_INFO_LINKS: Record<EnumBrowser, string> = {
		[EnumBrowser.MicrosoftEdge]		: 'https://support.microsoft.com/en-us/microsoft-edge/accessibility-features-in-microsoft-edge-4c696192-338e-9465-b2cd-bd9b698ad19a',
		[EnumBrowser.Opera]				: 'https://help.opera.com/en/latest/browser-window/#zoom',
		[EnumBrowser.GoogleChrome]		: 'https://support.google.com/chrome/answer/96810?hl=en&co=GENIE.Platform%3DDesktop',
		[EnumBrowser.InternetExplorer]	: 'https://support.microsoft.com/en-us/windows/internet-explorer-11-keyboard-shortcuts-bf5218a2-7626-b834-db7f-0633120e5620',
		[EnumBrowser.MozillaFirefox] 	: 'https://support.mozilla.org/en-US/kb/font-size-and-zoom-increase-size-of-web-pages#:~:text=Keyboard%20shortcuts%3A%20You%20can%20also,out%2C%20or%200%20to%20reset.',
		[EnumBrowser.Safari]			: 'https://support.apple.com/en-in/guide/safari/ibrw1068/mac',
		[EnumBrowser.Brave]				: 'https://support.google.com/chrome/answer/96810?hl=en&co=GENIE.Platform%3DDesktop',
		[EnumBrowser.Other]				: 'https://support.google.com/chrome/answer/96810?hl=en&co=GENIE.Platform%3DDesktop'
	};

	//** Getter Helpers */
	readonly EnumDevice: typeof EnumDevice = EnumDevice;

	//** Helper Variables */
	browser			 		: EnumBrowser;
	deviceType		 		: EnumDevice;
	scaleValuePercent		: number;
	isOpenMenuPragmatically : boolean;


	/**------------------------------------------------------
	 * Configurations
	 */
	constructor(
		public scaleLayoutService		: ScaleLayoutService,
		public appearancePreferenceService: AppearancePreferenceService,
		public deviceDetectionService	: DeviceDetectionService,
		public browserDetectionService	: BrowserDetectionService
	) {}


	/**------------------------------------------------------
	 * Lifecycle Hooks
	 */
	ngOnInit(): void {

		//0 - define the browser and device
		this.browser 	= this.browserDetectionService.getBrowser();
		this.deviceType = this.deviceDetectionService.getDevice();

		//1 - subscribe the global zoom level changes
		this.scaleLayoutService.onZoomChange$().subscribe((value: number) => {

			//a. don't set the same value again (avoiding a ui bug)
			const valuePercent: number = value * 100;
			if (this.scaleValuePercent === valuePercent) return;

			//b. set the new value
			this.scaleValuePercent = Math.floor(valuePercent);
		});

		//2 - open zoom layout
		this.openZoomLayout();
	}

	//** Get browser link */
	getBrowserLink(): string {
		return this.SCALING_INFO_LINKS[this.browser];
	}

	openZoomLayout(): void {
		this.scaleLayoutService.openZoomLayout$().subscribe((isOpen: boolean) => {
			if (!isOpen) return;
			this.zoomLayoutDropdown.open();
			this.isOpenMenuPragmatically = isOpen;
		});
	}

	onOpenChange(isOpen: boolean): void {
		if (!isOpen) this.isOpenMenuPragmatically = isOpen;
	}
}
